import { Component, computed, ElementRef, inject, model, OnInit, signal, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { StyleClassModule } from 'primeng/styleclass';
import { LayoutService } from '@/layout/service/layout.service';
import { AppBreadcrumb } from './app.breadcrumb';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { RippleModule } from 'primeng/ripple';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { AvatarModule } from 'primeng/avatar';
import { TokenService } from '@/core/service/token.service';
import { environment } from 'src/environments/environment';
import { UsuarioDataComponent } from '@/features/controle-acesso/usuario/usuario-data/usuario-data.component';
import { UsuarioService } from '@/features/controle-acesso/usuario/usuario.service';
import { UserService } from '@/core/service/user.service';
import { UsuarioModel } from '@/models/usuario';
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { AlertaUsuarioService } from '@/features/controle-acesso/services/alerta-usuario.service';
import { AlertaOSComplementarOutput, AlertaUsuarioOutput, MensagemUsuarioOutput } from '@/features/controle-acesso/models/alerta-usuario';
import { AtividadeTabsComponent } from '@/features/atividade/atividade/atividade-tabs/atividade-tabs.component';
import { guid } from '@fullcalendar/core/internal';

interface NotificationsBars {
    id: string;
    label: string;
    badge?: string | any;
    icon: string;
}

@Component({
    selector: '[app-topbar]',
    standalone: true,
    imports: [RouterModule, CommonModule, StyleClassModule, AppBreadcrumb, InputTextModule, ButtonModule, IconFieldModule, InputIconModule, RippleModule, BadgeModule, OverlayBadgeModule, AvatarModule, DialogModule, UsuarioDataComponent, AtividadeTabsComponent],
    template: `<div class="layout-topbar rounded" [ngClass]="menuColor">
        <div class="topbar-left">
            <a tabindex="0" #menubutton type="button" class="menu-button" (click)="onMenuButtonClick()">
                <i [class]="menuButtonIcon()"></i>
            </a>
            <img class="horizontal-logo" src="/layout/images/logo-white.svg" alt="diamond-layout" />
            <span class="topbar-separator"></span>
            <div app-breadcrumb></div>
            <img class="mobile-logo" src="/layout/images/logo-{{ isDarkTheme() ? 'white' : 'dark' }}.svg" alt="diamond-layout" />
        </div>

        <div class="topbar-right" >
            <ul class="topbar-menu items-start" [ngStyle]="{'align-items': 'flex-start'}">
                <!-- OS Complementar -->
                <li class="right-sidebar-item static sm:relative flex flex-col items-center">
                    <a class="right-sidebar-button relative z-50 flex items-center justify-center rounded-full hover:rounded-full" title="OS Complementar" (click)="getAlertaOSComplementar()" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <p-avatar styleClass="w-10! h-10! flex items-center justify-center bg-white! rounded-full! border border-surface-200">
                            <span *ngIf="selectedNotificationsBarData()('os-complementar').length > 0" class="w-2 h-2 rounded-full bg-red-500 absolute top-1 right-1 z-10"></span>
                            <i class="pi pi-star text-xl text-surface-700"></i>
                        </p-avatar>
                    </a>
                    <div
                        class="md:right-[-60px] lg:right-[-60px] xs:right-[-60px] list-none m-0 rounded-2xl border border-surface absolute bg-surface-0 dark:bg-surface-900 overflow-hidden hidden origin-top min-w-72 sm:w-120 mt-2 z-[100] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
                    >

                        <div class="flex items-center border-b border-surface">
                            @for (item of notificationsBarsFiltradas()('os-complementar'); track item.id; let i = $index) {
                                <button
                                    [ngClass]="{ 'border-surface-950 dark:border-surface-0': selectedNotificationBar() === item.id, 'border-transparent': selectedNotificationBar() !== item.id }"
                                    class="px-3.5 py-2 inline-flex items-center border-b gap-2"
                                    (click)="selectedNotificationBar.set(item.id)"
                                >
                                    <i [class]="item.icon" [ngClass]="{ 'text-surface-950 dark:text-surface-0': selectedNotificationBar() === item.id }"></i>
                                    <span class="ml-1" [ngClass]="{ 'text-surface-950 dark:text-surface-0': selectedNotificationBar() === item.id }" (click)="onNotificationMainClick(item)">{{ item.label }}</span>
                                    <p-badge *ngIf="item?.badge && item.badge !== '0'" [value]="item.badge" severity="success" size="small" class="rounded-md!" />
                                </button>
                            }
                        </div>
                        <ul class="flex flex-col divide-y divide-(--surface-border) max-h-80 overflow-auto">
                            @for (item of selectedNotificationsBarData()('os-complementar'); track item.guid; let i = $index) {
                                <li>
                                    <div class="flex items-start gap-3 px-6 py-3.5 cursor-pointer hover:bg-emphasis transition-all" (click)="onNotificationClick(item)">
                                        <p-overlay-badge [value]="item.new ? '!' : ''" [severity]="item.new ? 'danger' : 'secondary'" class="inline-flex shrink-0">
                                            <p-avatar size="normal" styleClass="!w-8 !h-8">
                                                <img [src]="item.image" class="rounded-lg w-full h-full object-contain" alt="notification" />
                                            </p-avatar>
                                        </p-overlay-badge>
                                        <div class="flex items-start gap-3 flex-1 min-w-0">
                                            <div class="flex flex-col flex-1">
                                                <span class="label-small text-left text-surface-950 dark:text-surface-0 font-semibold">{{ item.name }}</span>
                                                <div class="flex flex-col gap-0.5">
                                                    @for (campo of item.campos; track $index) {
                                                        <span class="label-xsmall text-left break-words">
                                                            @if (campo.rotulo) {
                                                                <span class="font-semibold">{{ campo.rotulo }}:</span>
                                                            }
                                                            {{ campo.valor }}
                                                        </span>
                                                    }
                                                </div>
                                                <span class="label-xsmall text-left text-surface-500">{{ item.time }}</span>
                                            </div>
                                            <p-badge *ngIf="item.new" value="Novo" severity="success" class="shrink-0" />
                                        </div>
                                    </div>
                                    <span *ngIf="i !== notifications().length - 1"></span>
                                </li>
                            }
                            @if (selectedNotificationsBarData()('os-complementar').length === 0) {
                                <li class="py-3 px-6"><p class="label-small text-left text-surface-500">Nenhuma notificação</p></li>
                            }
                        </ul>
                    </div>
                </li>
                <!-- Mensagens Usuário -->
                <li class="right-sidebar-item static sm:relative flex flex-col items-center">
                    <a class="right-sidebar-button relative z-50 flex items-center justify-center rounded-full hover:rounded-full" title="Mensagens" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <p-avatar styleClass="w-10! h-10! flex items-center justify-center bg-white! rounded-full! border border-surface-200">
                            <span *ngIf="selectedNotificationsBarData()('mensagens').length > 0" class="w-2 h-2 rounded-full bg-red-500 absolute top-1 right-1 z-10"></span>
                            <i class="pi pi-envelope text-xl text-surface-700"></i>
                        </p-avatar>
                    </a>
                    <div
                        class="md:right-[-60px] lg:right-[-60px] xs:right-[-60px] list-none m-0 rounded-2xl border border-surface absolute bg-surface-0 dark:bg-surface-900 overflow-hidden hidden origin-top min-w-72 sm:w-120 mt-2 z-[100] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
                    >

                        <div class="flex items-center border-b border-surface">
                            @for (item of notificationsBarsFiltradas()('mensagens'); track item.id; let i = $index) {
                                <button
                                    [ngClass]="{ 'border-surface-950 dark:border-surface-0': selectedNotificationBar() === item.id, 'border-transparent': selectedNotificationBar() !== item.id }"
                                    class="px-3.5 py-2 inline-flex items-center border-b gap-2"
                                    (click)="selectedNotificationBar.set(item.id)"
                                >
                                    <i [class]="item.icon" [ngClass]="{ 'text-surface-950 dark:text-surface-0': selectedNotificationBar() === item.id }"></i>
                                    <span class="ml-1" [ngClass]="{ 'text-surface-950 dark:text-surface-0': selectedNotificationBar() === item.id }" (click)="onNotificationMainClick(item)">{{ item.label }}</span>
                                    <p-badge *ngIf="item?.badge && item.badge !== '0'" [value]="item.badge" severity="success" size="small" class="rounded-md!" />
                                </button>
                            }
                        </div>
                        <ul class="flex flex-col divide-y divide-(--surface-border) max-h-80 overflow-auto">
                            @for (item of selectedNotificationsBarData()('mensagens'); track item.guid; let i = $index) {
                                <li>
                                    <div class="flex items-center gap-3 px-6 py-3.5 cursor-pointer hover:bg-emphasis transition-all" (click)="onNotificationClick(item)">
                                        <p-overlay-badge [value]="item.new ? '!' : ''" [severity]="item.new ? 'danger' : 'secondary'" class="inline-flex">
                                            <p-avatar size="large">
                                                <img [src]="item.image" class="rounded-lg" alt="notification" />
                                            </p-avatar>
                                        </p-overlay-badge>
                                        <div class="flex items-center gap-3 flex-1">
                                            <div class="flex flex-col flex-1">
                                                <span class="label-small text-left text-surface-950 dark:text-surface-0 font-semibold">{{ item.name }}</span>
                                                <span class="label-xsmall text-left line-clamp-2" [innerHTML]="item.description"></span>
                                                <span class="label-xsmall text-left text-surface-500">{{ item.time }}</span>
                                            </div>
                                            <p-badge *ngIf="item.new" value="Novo" severity="success" />
                                        </div>
                                    </div>
                                    <span *ngIf="i !== notifications().length - 1"></span>
                                </li>
                            }
                            @if (selectedNotificationsBarData()('mensagens').length === 0) {
                                <li class="py-3 px-6"><p class="label-small text-left text-surface-500">Nenhuma notificação</p></li>
                            }
                        </ul>
                    </div>
                </li>
                <!-- Alarmes -->
                <li class="right-sidebar-item static sm:relative flex flex-col items-center">
                    <a class="right-sidebar-button relative z-50 flex items-center justify-center rounded-full hover:rounded-full" title="Alertas" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <p-avatar styleClass="w-10! h-10! flex items-center justify-center bg-white! rounded-full! border border-surface-200">
                            <span *ngIf="selectedNotificationsBarData()('alertas').length > 0" class="w-2 h-2 rounded-full bg-red-500 absolute top-1 right-1 z-10"></span>
                            <i class="pi pi-bell text-xl text-surface-700"></i>
                        </p-avatar>
                    </a>
                    <div
                        class="md:right-[-60px] lg:right-[-60px] xs:right-[-60px] list-none m-0 rounded-2xl border border-surface absolute bg-surface-0 dark:bg-surface-900 overflow-hidden hidden origin-top min-w-72 sm:w-120 mt-2 z-[100] top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
                    >

                        <div class="flex items-center border-b border-surface">
                            @for (item of notificationsBarsFiltradas()('alertas'); track item.id; let i = $index) {
                                <button
                                    [ngClass]="{ 'border-surface-950 dark:border-surface-0': selectedNotificationBar() === item.id, 'border-transparent': selectedNotificationBar() !== item.id }"
                                    class="px-3.5 py-2 inline-flex items-center border-b gap-2"
                                    (click)="selectedNotificationBar.set(item.id)"
                                >
                                    <i [class]="item.icon" [ngClass]="{ 'text-surface-950 dark:text-surface-0': selectedNotificationBar() === item.id }"></i>
                                    <span class="ml-1" [ngClass]="{ 'text-surface-950 dark:text-surface-0': selectedNotificationBar() === item.id }" (click)="onNotificationMainClick(item)">{{ item.label }}</span>
                                    <p-badge *ngIf="item?.badge && item.badge !== '0'" [value]="item.badge" severity="success" size="small" class="rounded-md!" />
                                </button>
                            }
                        </div>
                        <ul class="flex flex-col divide-y divide-(--surface-border) max-h-80 overflow-auto">
                            @for (item of selectedNotificationsBarData()('alertas'); track item.guid; let i = $index) {
                                <li>
                                    <div class="flex items-center gap-3 px-6 py-3.5 cursor-pointer hover:bg-emphasis transition-all" (click)="onNotificationClick(item)">
                                        <p-overlay-badge [value]="item.new ? '!' : ''" [severity]="item.new ? 'danger' : 'secondary'" class="inline-flex">
                                            <p-avatar size="large">
                                                <img [src]="item.image" class="rounded-lg" alt="notification" />
                                            </p-avatar>
                                        </p-overlay-badge>
                                        <div class="flex items-center gap-3 flex-1">
                                            <div class="flex flex-col flex-1">
                                                <span class="label-small text-left text-surface-950 dark:text-surface-0 font-semibold">{{ item.name }}</span>
                                                <span class="label-xsmall text-left line-clamp-2" [innerHTML]="item.description"></span>
                                                <span class="label-xsmall text-left text-surface-500">{{ item.time }}</span>
                                            </div>
                                            <p-badge *ngIf="item.new" value="Novo" severity="success" />
                                        </div>
                                    </div>
                                    <span *ngIf="i !== notifications().length - 1"></span>
                                </li>
                            }
                            @if (selectedNotificationsBarData()('alertas').length === 0) {
                                <li class="py-3 px-6"><p class="label-small text-left text-surface-500">Nenhuma notificação</p></li>
                            }
                        </ul>
                    </div>
                </li>
                <li class="profile-item static sm:relative flex flex-col items-center">
                    <a class="right-sidebar-button relative z-50 flex items-center justify-center rounded-full hover:rounded-full" pStyleClass=".user-dropdown" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveActiveClass="animate-fadeout" leaveToClass="hidden" [hideOnOutsideClick]="true">
                        <p-avatar styleClass="w-10! h-10! flex items-center justify-center bg-white! rounded-full! border border-surface-200">
                            <i class="pi pi-user text-xl text-surface-700"></i>
                        </p-avatar>
                    </a>
                    <span class="text-sm text-surface-950 dark:text-surface-0 font-medium whitespace-nowrap mt-1 text-center">{{ userModel?.login }}</span>
                    <div
                        class="user-dropdown list-none p-2 m-0 rounded-2xl border border-surface overflow-hidden absolute bg-surface-0 dark:bg-surface-900 hidden origin-top w-52 mt-2 right-0 z-999 top-auto shadow-[0px_56px_16px_0px_rgba(0,0,0,0.00),0px_36px_14px_0px_rgba(0,0,0,0.01),0px_20px_12px_0px_rgba(0,0,0,0.02),0px_9px_9px_0px_rgba(0,0,0,0.03),0px_2px_5px_0px_rgba(0,0,0,0.04)]"
                    >
                        <ul class="flex flex-col gap-1">
                            <li>
                                <a class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer" (click)="openUserData()">
                                    <i class="pi pi-user"></i>
                                    <span>Dados do Usuário</span>
                                </a>
                            </li>
                            <li>
                                <a class="label-small dark:text-surface-400 flex gap-2 py-2 px-2.5 rounded-lg items-center hover:bg-emphasis transition-colors duration-150 cursor-pointer" (click)="logout()">
                                    <i class="pi pi-power-off"></i>
                                    <span>Deslogar</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <p-dialog *ngIf="displayDialog" [(visible)]="displayDialog" [style]="{ width: '850px', 'font-size': '11px' }" header="Dados do Usuário"
        [modal]="true" styleClass="fluid">
        <sigos-usuario-data *ngIf="displayDialog" [usuario]="userModel"></sigos-usuario-data>
    </p-dialog>

    <p-dialog
        [(visible)]="displayAtividadeDetail"
        [style]="{ height: '100vh', 'max-height': '100vh', width: '100%', 'max-width': '100%', overflow: 'hidden' }"
        [contentStyle]="{ 'max-height': '100vh', 'min-height': '90%', overflow: 'auto' }"
        header="Dados da OS"
        [modal]="true"
        styleClass="fluid"
        >
        <h4 *ngIf="!idAtividadeDetail">O usuário não possui as permissões necessárias para acessar essa página.</h4>
        <max-atividade-tabs *ngIf="displayAtividadeDetail && idAtividadeDetail" [idAtividade]="idAtividadeDetail"></max-atividade-tabs>
    </p-dialog>
    `,
    styles: [`
        @media screen and (max-width: 991px) {
            .layout-topbar .topbar-menu > li:first-child {
                margin-right: 0 !important;
                margin-left: auto !important;
            }
        }
    `],
    providers: [MessageService],
})
export class AppTopbar implements OnInit {

    private environmentUrl: string = '';
    public menuColor: string = '';

    displayDialog: boolean = false;
    userModel!: UsuarioModel;

    flagAlerta: boolean = false;
    flagMensagem: boolean = false;
    displayAtividadeDetail: boolean = false;
    idAtividadeDetail!: number;
    qtdeAlertas: number = 0;
    qtdeAlertasOsComplementar: number = 0;
    qtdeMensagens: number = 0;
    alertas: AlertaUsuarioOutput[] = [];
    alertasOsComplementar: AlertaOSComplementarOutput[] = [];
    mensagens: MensagemUsuarioOutput[] = [];
    existeAlerta: boolean = false;

    constructor(public userService: UserService,
        private usuarioService: UsuarioService,
        private alertaUsuarioService: AlertaUsuarioService) {

        this.environmentUrl = environment.ApiCore;
        if (this.environmentUrl.startsWith('https://localhost')) {
            this.menuColor = '!bg-gray-100';
        }
        if (this.environmentUrl.startsWith('https://dev.')) {
            this.menuColor = '!bg-green-100';
        }
        if (this.environmentUrl.startsWith('https://hml.')) {
            this.menuColor = '!bg-blue-100';
        }
    }

    ngOnInit(): void {
        this.flagAlerta = this.userService.hasPermission("WFM_ALERTA_CON");
        this.flagMensagem = this.userService.hasPermission("WFM_MENSAGEM_CON");

        this.getUsuarioModel();

        if (this.flagAlerta) {
            this.getAlertaUsuario();
            this.getAlertaOSComplementar();
        }

        if (this.flagMensagem) {
            this.getMensagem();
        }

        this.usuarioService.dialogUsuario.subscribe(buscarDados => {
            if (buscarDados) {
                this.displayDialog = false;
            }
        });
    }

    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());

    isStaticMenuInactive = computed(() => this.layoutService.layoutState().staticMenuDesktopInactive);

    menuButtonIcon = computed(() => {
        const isDesktop = this.layoutService.isDesktop();
        const isInactive = this.isStaticMenuInactive();

        // Em mobile, sempre usa o ícone de hambúrguer
        if (!isDesktop) {
            return 'pi pi-bars';
        }

        // Em desktop, alterna entre chevrons
        return isInactive ? 'pi pi-chevron-right' : 'pi pi-chevron-left';
    });

    @ViewChild('menubutton') menuButton!: ElementRef;

    notificationsBars = signal<NotificationsBars[]>([
        { id: 'os-complementar', label: 'OS Complementar', badge: '0', icon: 'label-small pi pi-star' },
        { id: 'mensagens', label: 'Mensagens', badge: '0', icon: 'label-small pi pi-envelope' },
        { id: 'alertas', label: 'Alertas', badge: '0', icon: 'label-small pi pi-bell' }
    ]);

    notificationsBarsFiltradas = computed(() =>
        (filtro: string) =>
        this.notificationsBars().filter(n => n.id === filtro)
    );

    notifications = signal<any[]>([
        { id: 'os-complementar', data: [] },
        { id: 'mensagens', data: [] },
        { id: 'alertas', data: [] }
    ]);

    selectedNotificationBar = model<string>('alertas');

    selectedNotificationsBarData = computed(() => {
        return (tipo: string) => {
            //const selected = this.notifications().find((f) => f.id === this.selectedNotificationBar());
            const selected = this.notifications().find((f) => f.id === tipo);
            return selected?.data ?? [];
        };
    });

    tokenService = inject(TokenService);

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    showRightMenu() {
        this.layoutService.toggleRightMenu();
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }

    toggleSearchBar() {
        this.layoutService.layoutState.update((value) => ({ ...value, searchBarActive: !value.searchBarActive }));
    }

    logout() {
        this.tokenService.removeToken();
        //this.userSubject.next(null);
        window.location.href = '/login';
    }

    getUsuarioModel() {
        this.usuarioService.findUsuarioById(this.userService.getUserId()).subscribe(
            (res) => {
                if (res) {
                    this.userModel = res;
                }
            },
            err => {
            },
        );
    }

    openUserData() {
        this.displayDialog = true;
    }

    onNotificationMainClick(notification: any) {
        const currentBar = this.selectedNotificationBar();


        // Processar baseado no tipo de notificação
        switch (currentBar) {
            case 'alertas':
                break;

            case 'os-complementar':
                this.setAlertaOSComplementar();
                break;

            case 'mensagens':
                break;
        }
    }

    onNotificationClick(notification: any) {

        // OS Complementar: abrir detalhes (max-atividade-tabs) e marcar como lida (POST)
        if (notification.idAtividadeOrigem != null) {
            if (notification.idAlertaAtividadeComplementarUsuario != null) {
                this.alertaUsuarioService.setAlertaOSComplementar([notification.idAlertaAtividadeComplementarUsuario.toString()]).subscribe();
            }
            this.openDialogAtividade(Number(notification.idAtividadeOrigem));
            return;
        }

        const currentBar = this.selectedNotificationBar();
        switch (currentBar) {
            case 'alertas':
                this.setAlertaUsuario();
                break;

            case 'mensagens':
                if (notification.idAtividade) {
                    this.setMensagem(notification.idAtividade);
                }
                break;
        }
    }

    // #region Alertas

    getAlertaUsuario() {
        this.alertaUsuarioService.getAlertaUsuario().subscribe(
            (res) => {
                this.alertas = res || [];

                if (this.alertas.length > 0) {
                    this.alertas.forEach(alerta => {
                        alerta.icone = alerta?.icone
                            ?.replace("glyphicon glyphicon-cog", "pi pi-cog")
                            .replace("glyphicon glyphicon-exclamation-sign", "pi pi-exclamation-circle")
                            .replace("glyphicon glyphicon-star", "pi pi-star-fill")
                            .replace("glyphicon glyphicon-star-empty", "pi pi-star")
                            .replace("glyphicon glyphicon-tag", "pi pi-tag")
                            .replace("glyphicon glyphicon-wrench", "pi pi-wrench");
                        alerta.texto = (alerta?.texto?.length ?? 0) > 124 ? alerta?.texto?.substring(0, 100) + '...' : alerta.texto;
                    });
                }

                this.qtdeAlertas = this.alertas?.filter(f => f.flagLeitura == false).length ?? 0;

                // Atualizar badge da aba de Alertas
                this.notificationsBars.update(list =>
                    list.map(item =>
                        item.id === 'alertas'
                            ? {
                                ...item,
                                badge: this.qtdeAlertas > 0 ? (this.qtdeAlertas > 99 ? '99+' : this.qtdeAlertas.toString()) : undefined
                              }
                            : item
                    )
                );

                // Mapear alertas para o formato de notificações
                const notificacoesAlertas = this.alertas.map(alerta => ({
                    image: '/assets/layout/images/alertas.png',
                    name: alerta.titulo || 'Alerta do Sistema',
                    description: alerta.texto || '',
                    time: this.formatDate(alerta.dataInicio),
                    new: !alerta.flagLeitura,
                    icon: alerta.icone,
                    url: alerta.url,
                    guid: this.gerarGuid()
                }));

                // Atualizar dados das notificações de Alertas
                this.notifications.update(list =>
                    list.map(item =>
                        item.id === 'alertas'
                            ? { ...item, data: notificacoesAlertas }
                            : item
                    )
                );
            },
            err => {
            }
        );
    }

    setAlertaUsuario() {
        let idsAlerta = this.alertas.map(m => m.idAlertaUsuario?.toString()!);
        if (idsAlerta?.length > 0) {
            this.alertaUsuarioService.setAlertaUsuario(idsAlerta).subscribe(
                (res) => {
                    if (res) {
                        //this.getAlertaUsuario();
                        this.qtdeAlertas = 0;
                    }
                },
                err => {
                },
            );
        }
    }

    verificaExisteAlerta() {
        this.alertaUsuarioService.verificaExisteAlerta().subscribe(
            (res) => {
                if (res) {
                    this.existeAlerta = true;
                }
            },
            err => {
            },
        );
    }

    getAlertaOSComplementar() {
        this.alertaUsuarioService.getAlertaOSComplementar().subscribe(
            (res) => {
                this.alertasOsComplementar = res || [];
                this.qtdeAlertasOsComplementar = this.alertasOsComplementar?.filter(f => f.flagLeitura == false).length ?? 0;

                // Atualizar badge da aba de OS Complementar
                this.notificationsBars.update(list =>
                    list.map(item =>
                        item.id === 'os-complementar'
                            ? {
                                ...item,
                                badge: this.qtdeAlertasOsComplementar > 0 ? (this.qtdeAlertasOsComplementar > 99 ? '99+' : this.qtdeAlertasOsComplementar.toString()) : undefined
                              }
                            : item
                    )
                );

                // Mapear OS Complementar para o formato de notificações
                const notificacoesOS = this.alertasOsComplementar.map(os => {
                    console.log('OS Complementar:', os);
                    const campos = this.parseTextoOsComplementar(os.texto);
                    return {
                    image: '/assets/layout/images/servico.png',
                    name: `OS #${this.getNumeroOsOriginal(campos)}`,
                    campos,
                    time: 'Recente',
                    new: !os.flagLeitura,
                    idAtividadeOrigem: os.idAtividadeOrigem,
                    idAtividade: os.idAtividadeOrigem,
                    idAlertaAtividadeComplementarUsuario: os.idAlertaAtividadeComplementarUsuario,
                    guid: this.gerarGuid()
                };
                });

                // Atualizar dados das notificações de OS Complementar
                this.notifications.update(list =>
                    list.map(item =>
                        item.id === 'os-complementar'
                            ? { ...item, data: notificacoesOS }
                            : item
                    )
                );
            },
            err => { }
        );
    }

    /** Quebra o texto do alerta (separado por </br>) em campos "Rótulo: valor". */
    private parseTextoOsComplementar(texto?: string): { rotulo: string; valor: string }[] {
        const linhas = (texto || 'Ordem de Serviço Complementar')
            .split(/<\/?br\s*\/?>/i)
            .map(l => l.trim())
            .filter(l => l.length > 0);

        return linhas
            .map(linha => {
                const idx = linha.indexOf(':');
                if (idx <= 0) {
                    return { rotulo: '', valor: linha };
                }
                return { rotulo: linha.substring(0, idx).trim(), valor: linha.substring(idx + 1).trim() };
            });
    }

    /** Número da OS Original (parte antes do " - ") extraído dos campos do texto. */
    private getNumeroOsOriginal(campos: { rotulo: string; valor: string }[]): string {
        const original = campos.find(c => c.rotulo.toLowerCase() === 'os original');
        return original?.valor.split(' - ')[0].trim() ?? '';
    }

    setAlertaOSComplementar() {
        let idsAlerta = this.alertasOsComplementar.filter(f => f.flagLeitura !== true).map(m => m.idAlertaAtividadeComplementarUsuario?.toString()!);
        if (idsAlerta?.length > 0) {
            this.alertaUsuarioService.setAlertaOSComplementar(idsAlerta).subscribe(
                (res) => {
                    if (res) {
                        //this.getAlertaOSComplementar();
                        this.qtdeAlertasOsComplementar = 0;
                    }
                },
                err => {
                },
            );
        }
    }

    getMensagem() {
        this.alertaUsuarioService.getMensagem().subscribe(
            (res) => {
                this.mensagens = res || [];
                this.qtdeMensagens = this.mensagens?.filter(f => f.flagLeitura == false).length ?? 0;

                // Atualizar badge da aba de Mensagens
                this.notificationsBars.update(list =>
                    list.map(item =>
                        item.id === 'mensagens'
                            ? {
                                ...item,
                                badge: this.qtdeMensagens > 0 ? (this.qtdeMensagens > 99 ? '99+' : this.qtdeMensagens.toString()) : undefined
                              }
                            : item
                    )
                );

                // Mapear mensagens para o formato de notificações
                const notificacoesMensagens = this.mensagens.map(msg => ({
                    image: '/assets/layout/images/messages.png',
                    name: msg.nomeFuncionarioOrigem || 'Usuário',
                    description: msg.assunto || msg.mensagem || 'Mensagem',
                    time: this.formatDate(msg.dataEnvio),
                    new: !msg.flagLeitura,
                    idAtividade: msg.idAtividade,
                    idMensagem: msg.idMensagem,
                    guid: this.gerarGuid()
                }));

                // Atualizar dados das notificações de Mensagens
                this.notifications.update(list =>
                    list.map(item =>
                        item.id === 'mensagens'
                            ? { ...item, data: notificacoesMensagens }
                            : item
                    )
                );
            },
            err => {
            }
        );
    }

    setMensagem(idAtividade?: number) {
        if (idAtividade) {
            this.alertaUsuarioService.setMensagem(idAtividade).subscribe(
                (res) => {
                    if (res) {
                        //this.getMensagem();
                        this.qtdeMensagens = 0;
                    }
                },
                err => {
                },
            );
        }
    }

    openDialogAtividade(idAtividade: number) {
        //if (idAtividade) {
        this.idAtividadeDetail = idAtividade;
        this.displayAtividadeDetail = true;
        //}
    }

    private formatDate(date?: Date): string {
        if (!date) return 'Recente';

        const now = new Date();
        const notificationDate = new Date(date);
        const diffMs = now.getTime() - notificationDate.getTime();
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMins / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMins < 1) return 'Agora';
        if (diffMins < 60) return `${diffMins} minuto${diffMins > 1 ? 's' : ''} atrás`;
        if (diffHours < 24) return `${diffHours} hora${diffHours > 1 ? 's' : ''} atrás`;
        if (diffDays === 1) return 'Ontem';
        if (diffDays < 7) return `${diffDays} dias atrás`;
        if (diffDays < 30) return `${Math.floor(diffDays / 7)} semana${Math.floor(diffDays / 7) > 1 ? 's' : ''} atrás`;

        return notificationDate.toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    }

    gerarGuid(): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // #endregion Alertas
}
